import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CookieConsentService } from '@core/services/cookie-consent.service';
import { EventTrackerService } from '@core/services/event-tracker.service';
import { ANALYTICS_EVENTS } from '@core/utils/AnalyticsEvents';

@Component({
    selector: 'app-consent-accept-button',
    templateUrl: './consent-accept-button.component.html',
    styleUrls: ['./consent-accept-button.component.css'],
    standalone: true,
})
export class ConsentAcceptButtonComponent implements OnInit {
    @Input() text: string = '';

    @Output() accepted = new EventEmitter();

    constructor(
        private cookieConsentService: CookieConsentService,
        private eventTrackerService: EventTrackerService
    ) {}

    ngOnInit(): void {}

    accept() {
        this.cookieConsentService.accept();
        this.accepted.emit(true);
        this.eventTrackerService.trackEvent(ANALYTICS_EVENTS.COOKIE_CONSENT, {
            given: true,
        });
    }
}
